import { render, staticRenderFns } from "./media-form.vue?vue&type=template&id=0c6e7235"
import script from "./media-form.vue?vue&type=script&lang=js"
export * from "./media-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports